import { render, staticRenderFns } from "./BigCommerceIcon.vue?vue&type=template&id=1837550f&scoped=true"
import script from "./BigCommerceIcon.vue?vue&type=script&lang=js"
export * from "./BigCommerceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1837550f",
  null
  
)

export default component.exports